import React, { useContext, useEffect, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import styled from 'styled-components'

// Component
import Card from './Card'

// Context
import FirebaseContext from '../context/FirebaseContext'

const Button = styled.button`
  font-size: 1.7rem;
  background-color: black;
  border: none;
  border-radius: 30%;
  padding: 0.5rem;
  cursor: pointer;
  color: white;
`

const Portfolio = () => {

  const { categories, apps, fetchCategories, fetchApps } = useContext( FirebaseContext )

  const title = useRef()

  useEffect(() => {
    
    if( categories.length === 0 ) fetchCategories()

    if( apps.length === 0 ) fetchApps()

  // eslint-disable-next-line
  }, [categories, apps])

  return (
    <>
      <div 
        className="tokyo_tm_portfolio"
        ref = { title }
      >
        <div className="tokyo_tm_title">
          <div className="title_flex">
            <div className="left">
              <span>Portfolio</span>
              <h3>Creative Portfolio</h3>
            </div>
          </div>
        </div>


        <div className="portfolio_filter">
          <Tabs >
            <TabList >
              <Tab>All</Tab>
              
              {categories.map(categorie => (
                
                <Tab
                  key = { categorie.id }
                >
                  { categorie.label }
                </Tab>

              ))}
              
            </TabList>
            
            <div className="list_wrapper">

                <TabPanel>

                  <ul className="portfolio_list">

                    {apps.map(app => (
                      
                      <li key = { app.id }>
                        <div className="inner">
                          
                          <Card 
                            app = { app }
                            color = { categories.find( c => c.key === app.categorie ).color }
                          />
                          
                        </div>
                      </li>
                      
                    ))}

                  </ul>
                  
                </TabPanel>
                
                {categories.map(categorie => (

                  <TabPanel
                    key = { categorie.id }
                  >

                    <ul className="portfolio_list">
                      
                      {apps.filter( i => i.categorie === categorie.key ).map(app => (
                            
                        <li key = { app.id }>
                          <div className="inner">
                            
                            <Card 
                              app = { app }
                              color = { categorie.color }
                            />
                            
                          </div>
                        </li>
                            
                      ))}
                      
                    </ul>

                  </TabPanel>
                  
                ))}
                
            </div>

            <Button
              onClick = { () => title.current.scrollIntoView({ behavior: "smooth" }) }
            >
              ↑
            </Button>
            
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
